import { ModuleSwitch } from "./ModuleSwitch";

// EOS-05 is one module with one sidebar entry, but more than one protection check
// (Master Prompt A20, A21, A33): this switch moves between them at the top of each page.
const PROTECTION_PAGES = [
  { to: "/starter-coordination", label: "Starter coordination" },
  { to: "/breaker-selectivity", label: "Breaker duty and selectivity" },
  { to: "/earth-fault-loop", label: "Earth-fault loop" },
] as const;

export function ProtectionSwitch() {
  return <ModuleSwitch label="Protection coordination" pages={PROTECTION_PAGES} />;
}

export default ProtectionSwitch;
